import React from "react";
import PropTypes from "prop-types";
import { NavLink as RouteNavLink } from "react-router-dom";
import { Navbar, NavbarBrand } from "shards-react";
// import ameBrand from '../../../images/ame_brand.svg'

class SidebarMainNavbar extends React.Component {
    static propTypes = {
        hideLogoText: PropTypes.bool,
        history: PropTypes.any
    };

    static defaultProps = {
        hideLogoText: false
    };

    render() {
        const { hideLogoText } = this.props;
        return (
            <div className="main-navbar">
                <Navbar
                    className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
                    type="light"
                    style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <NavbarBrand
                        tag={props => <RouteNavLink {...props} />}
                        className="mr-0"
                        to="/applications/1"
                        style={{ lineHeight: "25px" }}
                    >
                        <div className="d-table m-auto">
                            {!hideLogoText && (
                                <h1 style={{ fontSize: 18 }}>
                                    Portal de Eitri-Apps
                                </h1>
                            )}
                        </div>
                    </NavbarBrand>
                    <a
                        className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
                        href="#link"
                    >
                        <i className="material-icons">&#xE5C4;</i>
                    </a>
                </Navbar>
            </div>
        );
    }
}

export default SidebarMainNavbar;
